import React, { useState } from 'react';
import { Table, Card, DatePicker, Row, Col } from 'antd';
import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import { useSelector } from 'react-redux';
import { getProfitAndLoss } from '../../network/treeTable';
import Heading from '../../components/common/Heading/Heading';
import DashboardCards from '../Dashboard/DashboardCards';
const { RangePicker } = DatePicker;

const ProfitLoss = ({ t }) => {
  const { currentLang, companyName } = useSelector((state) => state.user);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [sourceData, setSourceData] = useState({
    from_date: dayjs().startOf('year').format('YYYY-MM-DD'),
    to_date: dayjs().format('YYYY-MM-DD'),
    fiscal_year: dayjs().format('YYYY'),
  });

  const onExpand = (expanded, record) => {
    setExpandedRowKeys((prev) => {
      if (expanded) {
        return [...prev, record.key];
      }
      return prev.filter((key) => key !== record.key);
    });
  };

  const { data: getTreeDataDetails, isLoading } = useQuery({
    queryKey: [
      queryKeys.getProfitAndLoss,
      currentLang,
      companyName,
      sourceData.from_date,
      sourceData.to_date,
      sourceData.fiscal_year,
    ],
    queryFn: () =>
      getProfitAndLoss(
        currentLang,
        companyName,
        sourceData.from_date,
        sourceData.to_date,
        sourceData.fiscal_year
      ),
  });

  const columns = getTreeDataDetails?.message?.columns?.map((col) => ({
    title: col?.label,
    dataIndex: col?.fieldname,
    key: col?.fieldname,
  }));

  const buildAccountsTree = (accounts) => {
    const map = new Map();

    accounts?.forEach((account) => {
      map.set(account?.account, { ...account, key: account?.account });
    });

    const result = [];
    accounts?.forEach((account) => {
      if (account?.parent_account) {
        const parent = map.get(account.parent_account);
        if (parent) {
          if (!parent.children) {
            parent.children = [];
          }
          parent.children.push(map.get(account.account));
        }
      } else {
        result.push(map.get(account.account));
      }
    });
    const cleanTree = (nodes) => {
      return nodes?.map((node) => {
        const { children, ...rest } = node;
        return children && children.length > 0
          ? { ...rest, children: cleanTree(children) }
          : rest;
      });
    };

    return cleanTree(result.filter((account) => account?.key !== undefined));
  };

  const accountsTree = buildAccountsTree(
    getTreeDataDetails?.message?.result || []
  );
  console.log(accountsTree);

  return (
    <div>
      {/* <Heading title={t.reports} subTitle={t.ProfitLoss} path="/" /> */}
      <DashboardCards t={t} />
      <Card className="mt-5">
        <Row
          style={{
            marginBottom: 20,
          }}
          gutter={[16, 16]}
        >
          <Col xs={24} md={12}>
            <RangePicker
              format="YYYY/MM/DD"
              style={{ width: '100%' }}
              placeholder={['From Date', 'To Date']}
              defaultValue={[dayjs().startOf('year'), dayjs()]}
              value={[dayjs(sourceData.from_date), dayjs(sourceData.to_date)]}
              onChange={(dates, dateStrings) => {
                setSourceData({
                  ...sourceData,
                  from_date: dateStrings[0],
                  to_date: dateStrings[1],
                });
              }}
            />
          </Col>
          <Col xs={24} md={12}>
            <DatePicker
              style={{ width: '100%' }}
              placeholder="Fiscal Year"
              defaultValue={dayjs().format('YYYY')}
              value={dayjs(sourceData.fiscal_year)}
              format="YYYY"
              onChange={(date, dateString) => {
                setSourceData({
                  ...sourceData,
                  fiscal_year: dateString,
                });
              }}
            />
          </Col>
        </Row>

        <Table
          className="table_custom"
          columns={columns}
          dataSource={accountsTree}
          // expandable={{
          //   expandedRowKeys,
          //   onExpand,
          //   rowExpandable: (record) => !!record.children && record.children.length > 0,
          //   expandedRowRender: (record) => renderChildren(record),
          // }}
          loading={isLoading}
          pagination={{ hideOnSinglePage: true }}
          // rowKey="key"
          scroll={{ x: 'max-content' }}
        />
      </Card>
    </div>
  );
};

export default ProfitLoss;
